/** Request persistent IndexedDB where supported (best-effort; not required for M5). */
export async function requestPersistentStorageIfSupported(): Promise<
  'granted' | 'denied' | 'unsupported'
> {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) {
    return 'unsupported'
  }
  try {
    const granted = await navigator.storage.persist()
    return granted ? 'granted' : 'denied'
  } catch {
    return 'denied'
  }
}
